import {
  onStoreVisualViewport,
  resolveStoreVisibleFrame,
  startStoreVisualViewport,
} from '~/utils/storeVisualViewport'

const SESSION_FLAG = 'cs-flutter-studio'

function isFlutterStudioEmbed(route: { query: Record<string, unknown> }): boolean {
  if (route.query.studio === 'app') {
    try {
      sessionStorage.setItem(SESSION_FLAG, '1')
    }
    catch {
      // Ignore — embed mode still works for this navigation.
    }
    return true
  }
  try {
    return sessionStorage.getItem(SESSION_FLAG) === '1'
  }
  catch {
    return false
  }
}

function syncFlutterEmbedViewport() {
  const frame = resolveStoreVisibleFrame()
  document.documentElement.style.setProperty('--cs-embed-height', `${frame.h}px`)
  document.documentElement.style.setProperty('--cs-embed-width', `${frame.w}px`)
  document.documentElement.classList.add('cs-flutter-embed')
  document.body.classList.add('cs-flutter-embed')
}

/**
 * Flutter's in-app store design studio (WebView / iframe).
 *
 * WKWebView often reports a layout viewport taller than the visible embed,
 * which pins `position:fixed` owner chrome below the clipped WebView edge.
 * Pin shell height to the visible frame and re-sync on resize / keyboard.
 */
export default defineNuxtPlugin({
  name: 'flutter-studio-embed',
  setup(nuxtApp) {
    if (!import.meta.client) return

    const route = useRoute()
    if (!isFlutterStudioEmbed(route)) return

    startStoreVisualViewport()
    syncFlutterEmbedViewport()
    onStoreVisualViewport(syncFlutterEmbedViewport)
    nuxtApp.hook('page:finish', () => syncFlutterEmbedViewport())

    const onSessionReady = () => {
      const { loadSession } = useAuth()
      void loadSession().then(() => syncFlutterEmbedViewport())
    }
    window.addEventListener('cs-flutter-session-ready', onSessionReady)
  },
})
